(function() {
  var ValidationEngine,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ValidationEngine = App.loadClass('core::ValidationEngine');

  exports.RuppOrdersDialogCustomersHandler = (function(superClass) {
    extend(RuppOrdersDialogCustomersHandler, superClass);

    function RuppOrdersDialogCustomersHandler() {
      this.afterLoadData = bind(this.afterLoadData, this);
      this.updateName = bind(this.updateName, this);
      this.calculateBilling = bind(this.calculateBilling, this);
      this.afterLoadLayout = bind(this.afterLoadLayout, this);
      this.init = bind(this.init, this);
      return RuppOrdersDialogCustomersHandler.__super__.constructor.apply(this, arguments);
    }

    RuppOrdersDialogCustomersHandler.prototype.init = function() {
      this.layoutSelector = '#orders_steps_container';
      this.layoutUrl = 'backend/grower/rupp-orders/load-layout-customers';
      this.subHandlers = {
        Licenses: {
          "class": 'grower::handlers/rupp_orders/RuppOrdersLicensesHandler'
        }
      };
      this.dataLoaded = false;
      return this.loadLayout();
    };

    RuppOrdersDialogCustomersHandler.prototype.afterLoadLayout = function(selector, response) {
      var func, ref, ths;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      ths = this;
      $('.orders_customers_container').delegate('.cust_header', 'click', function() {
        $(this).next().toggle();
        return $(this).find('.header-icon').toggle();
      });
      $('.orders_customers_container').delegate('.btn_cust_delete', 'click', function(e) {
        ths.parent.deleteFormData('customers', $(this).data('dynamic-id'));
        $(this).closest('.cust_header').next().remove().end().remove();
        ths.calculateBilling();
        return e.stopPropagation();
      });
      func = function(e) {
        var header, i, len, ref1;
        ref1 = $('.cust_header');
        for (i = 0, len = ref1.length; i < len; i++) {
          header = ref1[i];
          if (($(header).next().is(':visible')) === ($(this).attr('id') === 'collapse')) {
            $(header).next().toggle();
            $(header).find('.header-icon').toggle();
          }
        }
        return $('.collapse_all').toggle();
      };
      $('#collapse').bind('click', func);
      $('#expand').bind('click', func);
      $('.orders_customers_container').delegate('.sel_cust_name', 'change', function() {
        var curr, docontinue, info;
        info = ths.taffyObjects['customers']({
          id: {
            '==': $(this).val()
          }
        });
        curr = $(this);
        docontinue = true;
        $('.orders_customers_container').find('.sel_cust_name').each(function() {
          if (!$(this).is(curr)) {
            if ($(this).val() === curr.val()) {
              curr.val('');
              return docontinue = false;
            }
          }
        });
        if (!docontinue) {
          return;
        }
        $(this).closest('.cust-info').find('.txt_cust_address1').val(info.select('address1')).end().find('.txt_cust_address2').val(info.select('address2')).end().find('.txt_cust_city').val(info.select('city')).end().find('.txt_cust_state').val(info.select('state')).end().find('.txt_cust_zipcode').val(info.select('zipcode')).end().find('.txt_cust_operation').val(info.select('rupp_operation')).end().find('.txt_cust_phone').val(info.select('phone')).end().find('.txt_cust_email').val(info.select('email')).end();
        ths.updateName(this);
        if ($(this).data('dynamic-id') === 0 && ths.dataLoaded) {
          $('#customers_container .orders_customers_sidebar #address1').val(info.select('address1'));
          $('#customers_container .orders_customers_sidebar #address2').val(info.select('address2'));
          $('#customers_container .orders_customers_sidebar #city').val(info.select('city'));
          $('#customers_container .orders_customers_sidebar #state').val(info.select('state'));
          return $('#customers_container .orders_customers_sidebar #zipcode').val(info.select('zipcode'));
        }
      });
      this.cust_id = 0;
      $('#btn_add_customer').bind('click', function() {
        var cust_id, data, remainder;
        cust_id = $(this).data('id');
        $(this).removeData('id');
        if (cust_id == null) {
          cust_id = ths.cust_id;
        }
        remainder = Math.max(0, 100 - ths.calculateBilling(false));
        data = $('.add-cust-tmpl').render({
          cust_id: cust_id,
          cust_billing: remainder
        });
        data = $($.parseHTML(data));
        data.find('.txt_cust_phone').mask('?999 999 9999');
        data.find('.txt_cust_zipcode').mask('?99999');
        data.find('.order-data').attr('data-dynamic-btn', '#btn_add_customer');
        data.find('.order-data').attr('data-dynamic-id', cust_id);
        data.find('.btn_cust_delete').attr('data-dynamic-id', cust_id);
        if (parseInt(cust_id) === 0) {
          data.find('.btn_cust_delete').remove();
          data.find('.hdn-primary-cust').val('true');
        } else {
          data.find('#btn_licenses').remove();
          data.find('.txt_cust_phone, .txt_cust_email').removeClass('validate-required');
        }
        data.appendTo('.orders_customers_container');
        ths.calculateBilling();
        return ths.cust_id = parseInt(cust_id) + 1;
      });
      $('.orders_customers_container').delegate('.txt_cust_billing', 'click', function(e) {
        return e.stopPropagation();
      });
      $('.orders_customers_container').delegate('.txt_cust_billing', 'change', function(e) {
        var elem, i, len, ref1;
        $(this).val(Math.min(100, Math.max(0, $(this).val())));
        if ($('.txt_cust_billing').length === 2 && ths.dataLoaded) {
          ref1 = $('.txt_cust_billing');
          for (i = 0, len = ref1.length; i < len; i++) {
            elem = ref1[i];
            if (!$(elem).is(this)) {
              $(elem).val(100 - $(this).val());
            }
          }
        }
        return ths.calculateBilling();
      });
      $('#delivery_date').datepicker();
      $('#zipcode').mask('?99999');
      $('.orders_customers_container').delegate('#btn_licenses', 'click', (function(_this) {
        return function(e) {
          var dlg;
          dlg = _this.createSubHandler('Licenses');
          if (dlg) {
            dlg.loadLayoutPostOptions = {
              'users_id': $(e.target).closest('.cust_header').next().find('.sel_cust_name').val()
            };
            dlg.init();
          }
          return e.stopPropagation();
        };
      })(this));
      $('#btn_size').click((function(_this) {
        return function(e) {
          var dlg;
          dlg = _this.createSubHandler('Sizes');
          if (dlg) {
            return dlg.init();
          }
        };
      })(this));
      $('#btn_weight').click((function(_this) {
        return function(e) {
          var dlg;
          dlg = _this.createSubHandler('Weights');
          if (dlg) {
            return dlg.init();
          }
        };
      })(this));
      if (this.parent.editable) {
        this.validator = new ValidationEngine();
        this.validator.makeFormValidator('customers', '#customers_container', '#customers_errors', (function(_this) {
          return function(valid) {
            if (valid) {
              return _this.parent.gotoNext();
            }
          };
        })(this));
        this.validator.registerRule({
          selector: '.validate-afterOrderDate',
          text: 'Delivery date must be after order date',
          func: function(elem) {
            return Date.parse(elem.val()) > Date.parse($('.orders_customers_sidebar #order_date').val());
          }
        });
        this.validator.registerRule({
          selector: '.validate-isLTE100',
          text: 'Billing % must be 100% or less',
          func: function(elem) {
            return parseInt(elem.val()) <= 100;
          }
        });
        this.validator.registerRule({
          selector: '.validate-equals100',
          text: 'Total Billing % must equal 100',
          func: function(elem) {
            return parseInt(elem.val()) === 100;
          }
        });
        this.validator.registerRule({
          selector: '.validate-isInteger',
          text: 'Billing % must be an integer',
          func: function(elem) {
            return parseInt(elem.val()) === parseFloat(elem.val());
          }
        });
        this.validator.registerRule({
          selector: 'select[name="sales_rep_fk"]',
          text: 'You must change the sales rep on this order',
          func: (function(_this) {
            return function(elem) {
              var data;
              data = response.data;
              return !data.require_rep_change || parseInt(data.orig_rep) !== parseInt(elem.val());
            };
          })(this)
        });
      }
      this.parent._handleResize();
      this.parent.loadFormData();
      return this.parent.dialog.find('.message_writer').message_writer({
        autoHide: false
      });
    };

    RuppOrdersDialogCustomersHandler.prototype.calculateBilling = function(update) {
      var e, i, len, ref, sum;
      if (update == null) {
        update = true;
      }
      sum = 0;
      ref = $('.txt_cust_billing');
      for (i = 0, len = ref.length; i < len; i++) {
        e = ref[i];
        sum += parseInt($(e).val());
      }
      if (update) {
        $('input[name="total_billing_percent"]').val(sum);
      }
      return sum;
    };

    RuppOrdersDialogCustomersHandler.prototype.updateName = function(elem) {
      var ths;
      ths = this;
      return $(elem).each(function() {
        var name;
        name = ths.taffyObjects['customers']({
          id: {
            '==': $(this).val()
          }
        }).select('name')[0];
        if (!name) {
          $(ths.layoutSelector).find('#btn_licenses').prop('disabled', true);
        } else {
          $(ths.layoutSelector).find('#btn_licenses').button('reset');
        }
        if (name == null) {
          name = '';
        }
        return $(this).closest('div.cust-info').prev().find('.cust_name').html(name);
      });
    };

    RuppOrdersDialogCustomersHandler.prototype.afterLoadData = function() {
      this.updateName('.sel_cust_name');
      this.calculateBilling();
      return this.dataLoaded = true;
    };

    return RuppOrdersDialogCustomersHandler;

  })(Handler);

}).call(this);
